// src/store/paymentSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiFetch from "../../utlis/apiFetch";

export const createPaymentIntent = createAsyncThunk(
  "payment/createIntent",
  async ({ amount, applicationId }, { rejectWithValue }) => {
    try {
      const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/bankdetails/createPaymentIntent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount: Math.round(amount * 100), applicationId }),
      });

      const data = response._data ?? await response.json();
      if (data.error) throw new Error(data.error);

      return data.clientSecret;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    clientSecret: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createPaymentIntent.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPaymentIntent.fulfilled, (state, action) => {
        state.loading = false;
        state.clientSecret = action.payload;
      })
      .addCase(createPaymentIntent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default paymentSlice.reducer;
